if (!customElements.get('policy-service-grid')) {
  customElements.define(
    'policy-service-grid',
    class PolicyServiceGrid extends HTMLElement {
      connectedCallback() {
        if (this.dataset.policyServiceReady === 'true') return;

        this.dataset.policyServiceReady = 'true';
        this.dialog = this.querySelector('[data-policy-service-dialog]');
        this.dialogContent = this.querySelector('[data-policy-service-content]');
        this.abortController = new AbortController();

        this.addEventListener('click', (event) => this.handleClick(event), {
          signal: this.abortController.signal,
        });
        this.dialog?.addEventListener('close', () => this.cleanupDialog(), {
          signal: this.abortController.signal,
        });
      }

      disconnectedCallback() {
        delete this.dataset.policyServiceReady;
        this.abortController?.abort();
        this.cleanupDialog();
      }

      handleClick(event) {
        const closeButton = event.target.closest('[data-policy-service-close]');
        if (closeButton && this.contains(closeButton)) {
          this.closeDialog();
          return;
        }

        if (event.target === this.dialog) {
          this.closeDialog();
          return;
        }

        const opener = event.target.closest('[data-policy-service-open]');
        if (opener && this.contains(opener)) this.openDialog(opener);
      }

      openDialog(opener) {
        if (!this.dialog || !this.dialogContent) return;

        const template = document.getElementById(opener.dataset.policyServiceTemplate);
        if (!(template instanceof HTMLTemplateElement)) return;

        this.returnFocusTarget = opener;
        this.dialogContent.replaceChildren(template.content.cloneNode(true));
        this.dialog.setAttribute(
          'aria-label',
          opener.dataset.policyServiceLabel || 'Service information'
        );

        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }

        document.documentElement.classList.add('policy-service-grid-open');
        this.querySelector('[data-policy-service-close]')?.focus({ preventScroll: true });
      }

      closeDialog() {
        if (!this.dialog) return;

        if (typeof this.dialog.close === 'function' && this.dialog.open) {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          this.cleanupDialog();
        }
      }

      cleanupDialog() {
        document.documentElement.classList.remove('policy-service-grid-open');
        this.dialogContent?.replaceChildren();
        this.returnFocusTarget?.focus({ preventScroll: true });
        this.returnFocusTarget = null;
      }
    }
  );
}
